import React from 'react';
import { Col, Modal, Row } from 'react-bootstrap';

const ProfileSupportForChangeModal = (props) => {
  const { project, show, onHide, status } = props;
  const { stakeholderFields } = project;
  const supportName = stakeholderFields.find(
    (field) => field.nativeColumn === 'support'
  ).name;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 400 }}>{supportName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="m-b-16">
          <Col
            xs={12}
            className={`${status === 'Very Supportive' ? '' : 'text-muted'} modal-key-label m-b-16`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-very-supportive"
            />
            <span>Very Supportive</span>
          </Col>
          <Col
            xs={12}
            className={`${status === 'Supportive' ? '' : 'text-muted'} modal-key-label m-b-16`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-supportive"
            />
            <span>Supportive</span>
          </Col>
          <Col
            xs={12}
            className={`${status === 'Neutral' ? '' : 'text-muted'} modal-key-label m-b-16`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-neutral"
            />
            <span>Neutral</span>
          </Col>
          <Col
            xs={12}
            className={`${status === 'Unsupportive' ? '' : 'text-muted'} modal-key-label m-b-16`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-unsupportive"
            />
            <span>Unsupportive</span>
          </Col>
          <Col
            xs={12}
            className={`${status === 'Very Unsupportive' ? '' : 'text-muted'} modal-key-label`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-very-unsupportive"
            />
            <span>Very Unsupportive</span>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default ProfileSupportForChangeModal;
